import { render } from "./MenulistView.vue?vue&type=template&id=531f91be&scoped=true"
import script from "./MenulistView.vue?vue&type=script&lang=js"
export * from "./MenulistView.vue?vue&type=script&lang=js"

import "./MenulistView.vue?vue&type=style&index=0&id=531f91be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531f91be"]])

export default __exports__